var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.421,
    height: 16.456,
    viewBox: "0 0 14.421 16.456",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5283",
    "data-name": "Group 5283",
    transform: "translate(-533.814 -111.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.667,2.334A2.334,2.334,0,1,1,2.334,0,2.334,2.334,0,0,1,4.667,2.334Z",
    transform: "translate(538.69 116.402)",
    fill: "none",
    stroke: "#292d32",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M.182,4.854c1.473-6.477,11.07-6.47,12.536.007.86,3.8-1.5,7.016-3.575,9.006a3.885,3.885,0,0,1-5.393,0C1.685,11.878-.679,8.654.182,4.854Z",
    transform: "translate(534.575 112.521)",
    fill: "none",
    stroke: "#292d32",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.520d42b7b407c2848a622d0189131954.svg";
export { ForwardRef as ReactComponent };